/* RESPONSIBLE TEAM: team-inbox-management */
export enum AttributeCollectorType {
  BotWorkflow = 0,
  NotificationChannel = 1,
  UpfrontCollection = 2,
  QualificationAttributes = 3,
}
